import styled from 'styled-components';

export const Container = styled.div`
    font-size: 1rem;
    margin: auto;
`;

export const Header = styled.div`
    display: flex;
    font-size: 2rem;
    flex-direction: column;
    padding-bottom: 1.5rem;
    margin: auto;
`;

const defaultSpan = styled.span`
    padding-bottom: 0.5rem;
`;

export const Title = styled(defaultSpan)`
    font-size: 1em;
    font-weight: bold;
    padding-bottom: 0.5rem;
`;

export const Text = styled(defaultSpan)`
    font-size: 0.7em;
`;
